import { render, staticRenderFns } from "./BasePDFVisor.vue?vue&type=template&id=4e32b768&"
import script from "./BasePDFVisor.vue?vue&type=script&lang=js&"
export * from "./BasePDFVisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports